import { strapiRequest } from '../request'

export enum PolicyDocumentURL {
  SubscriptionTerms = 'subscription-terms-and-conditions',
  TermsAndConditions = 'terms-and-conditions',
  PrivacyPolicy = 'privacy-policy',
  CancellationPolicy = 'cancellation-policy',
  TermsOfService = 'terms-of-service',
}

export interface PolicyDocument {
  id: number
  attributes: {
    title: string
    urlSlug: string
    section: Array<{
      id: number
      title: string
      content: string
      required: boolean
    }>
  }
}

export interface GetPolicyDocumentResult {
  data: Array<PolicyDocument>
}

export async function getPolicyDocument(pageTitle: string) {
  const encodedPageTitle = encodeURIComponent(pageTitle)
  return strapiRequest<GetPolicyDocumentResult>(
    `/api/policy-documents?filters[urlSlug][$eq]=${encodedPageTitle}&populate=*&localeFallback=en`
  )
}
